<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/xushui/xs.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器徐水工厂
                </div>
                <div class="manufacture-t2">
                    位于河北省保定市徐水区，2015年10月工厂奠基，占地面积14.5万平方米<br />
                    主要生产7DCT、150/200kW电桥总成，具备总装能力120万台/年，50万轴齿、70万壳体自制能力。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7DCT组装1/2/3/4线、3eAD150组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 高度自动化：采用100%自动化设计和精密定位、对接系统，来料自动装夹，实时监控关键测试参数，测试结果自动反馈，测试数据自动分析、存储，可输出测试曲线<br />
                                ② 精准控制与高重复性：采用高性能西门子电机和控制系统，可完全模拟整车工况进行测试；过程参数闭环控制，可仿真整车信号，通过变速器TCU数据校验保证数据一致性和有效性，测试过程和测试参数高度一致<br />
                                ③ 高集成化和智能化：采用可编程测试软件，可实现多产品兼容测试，软件拓展能力强；集成国际尖端NVH分析系统，通过转速扭矩的波动分析，实时在线精确检测变速器噪音<br />
                                ④ 效率与成本：100%自动化与90%可动率结合，实现整体测试效率和质量的双重保证
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7eAD200组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① NVH采用机器人对接，更具有灵活性<br />
                                ② 交检软禁添加网络安全要求，并使用一机一密加密形式
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7eAD150组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 辅助压紧机构采用快换形式对接，方便对磨损的机构进行更换和维修<br />
                                ② 加爪压紧点采用铜片过渡，放止压紧损伤工件<br />
                                ③ NVH传感器采用最新的尾部出线形式，此方案使用寿命更长
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs3-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>



    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器徐水工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/tr/xushui.html'
};

import { createApp } from 'vue';
import App from './xushui.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./xushui.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
